import moment from "moment"

import { ICardContractFiles, IFilesList } from "./types"

import { useDeviceType } from '@hooks/useDeviceType'

import imgEmty from '@img/empty.svg'
import { IconDelete, IconDownload } from "@img/icons"

import { Empty, Flex, ToolTip, Divider, Button, Table, Checkbox } from "@ui/index"

import css from './ui.tab.files.module.scss'


/** Вкладка файлы */
export const CardContractTabFiles = ({
    filesList, handlerDeleteFiles, handlerDownloadFiles, handlerSelectedFiles, handlerSelectedFilesAll, handlerOpenModalPreview
}: ICardContractFiles) => {
    const deviceType = useDeviceType()

    const filesBySection = filesList.value.reduce<Array<{ sectionName: string, items: IFilesList[] }>>((acc, item) => {
        const currentSection = acc[acc.length - 1]

        if (!currentSection || currentSection.sectionName !== item.sectionName) {
            acc.push({ sectionName: item.sectionName, items: [item] })
        } else {
            currentSection.items.push(item)
        }

        return acc
    }, [])

    return <>
        <Table.Header paddingLeft='8px' paddingRight='86px' classNameContent={css['table_grid_columns_header']}>
            <Checkbox left='5px' isDisabled={filesList.value.length === 0} onChange={handlerSelectedFilesAll}
                checked={(filesList.value.length > 0 && filesList.value.filter(item => item.isSelected).length === filesList.value.length)}
            />

            <p>Наименование файла<br />Размер файла</p>
            <p className={css['hidden_500']} style={{textAlign: 'center'}}>Дата создания</p>
        </Table.Header>

        <Table.Content gap='8px'>
            {filesList.value.length === 0
                ? <Empty image={imgEmty} title="Файлы отсутствуют" />
                : filesBySection.map((section) => (
                    <Flex key={section.sectionName} gap='4px'>
                        <Divider prefix={<h4>{section.sectionName}</h4>} />

                        {section.items.map((item) => (
                            <Table.Row key={item.fileID} className={css['table_grid_columns_row']} onClick={() => handlerOpenModalPreview(true, item.filePath, item.fileName)}>
                                <Checkbox left='5px' isDisabled={filesList.value.length === 0}
                                    onChange={() => handlerSelectedFiles(item.fileID)}
                                    onClick={(e) => e.stopPropagation()}
                                    checked={item.isSelected}
                                />

                                <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                    <p>{item.fileName}</p>
                                    <p style={{ opacity: '.8' }}>Размер файла: {item.fileSize}</p>
                                </div>

                                <div className={css['hidden_500']} style={{textAlign: 'center'}}>
                                    <p>{moment(item.dateCreate).format('DD.MM.YYYY')}</p>
                                    <p>{moment(item.dateCreate).format('HH:mm:ss')}</p>
                                </div>

                                <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                    <ToolTip title='Скачать' placement="bottomRight">
                                        <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}
                                            onClick={(e) => {
                                                handlerDownloadFiles(item.fileID)
                                                e.stopPropagation()
                                            }}
                                        ><IconDownload width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                    </ToolTip>

                                    <ToolTip title='Удалить' placement="bottomRight">
                                        <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}
                                            onClick={(e) => {
                                                handlerDeleteFiles(item.fileID)
                                                e.stopPropagation()
                                            }}
                                        ><IconDelete width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                    </ToolTip>
                                </Flex>
                            </Table.Row>
                        ))}
                    </Flex>
                ))
            }
        </Table.Content>
    </>
}